import { Button, TableCell, TableRow } from "@material-ui/core";
import { memo, useState } from "react";
import { ModalCargarDatosFacturacionSinCotizacion } from "./DetalleFacturacionSinCotizacion/ModalCargarDatosFacturacionSinCotizacion";
import { ESTADOS_AUDITORIAFACTURACION_COMPRAS } from "../../../utils/constants";
import { useSelector } from "react-redux";
import { ModalAceptarFacturacion } from "./ModalAceptarFacturacion";
import { ModalCargarDatosFacturacionConCotizacion } from "./DetalleFacturacionConCotizacion/ModalCargarDatosFacturacionConCotizacion";
import { ModalTrackingFacturacion } from "./Tracking/ModalTrackingFacturacion";
import InfoHistorialIcon from "../../autorizaciones/UI/InfoHistorialIcon";
import { ModalEnviarAPagadas } from "./ModalEnviarApagadas";


export const ComprobantesItem = memo((props) => {
    const { comprobante,estado } = props;
    const [openModalCargarDatosSinCotizacion, setOpenCargarDatosSC] = useState(false);
    const [openModalCargarDatosConCotizacion, setOpenCargarDatosCC] = useState(false);
    const [openModalAceptarFacturacion, setOpenModalAceptarFacturacion] = useState(false);
    const [openModalTracking, setOpenModalTracking] = useState(false);
    const [esCarga, setEsCarga] = useState(false);
    const { estadosFacturacionSelect } = useSelector((state) => state.auditoriaFacturacion);
    const [openModalEnviarAPagadas, setOpenModalEnviarAPagadas] = useState(false);

    const handleOpenModal = (idSolicitud) => {
        
        if (idSolicitud == null) {
            setOpenCargarDatosSC(true);
        } else {
            setOpenCargarDatosCC(true);
        }
    }
    console.log(estadosFacturacionSelect)
    return (
        <>
            {
                openModalCargarDatosSinCotizacion &&
                <ModalCargarDatosFacturacionSinCotizacion
                    open={openModalCargarDatosSinCotizacion}
                    closeModalHandler={() => { setOpenCargarDatosSC(false); }}
                    comprobante={comprobante}
                />
            }
            {
                openModalCargarDatosConCotizacion &&
                <ModalCargarDatosFacturacionConCotizacion
                    open={openModalCargarDatosConCotizacion}
                    closeModalHandler={() => { setOpenCargarDatosCC(false) }}
                    comprobante={comprobante}
                />
            }
            {
                openModalAceptarFacturacion &&
                <ModalAceptarFacturacion
                    open={openModalAceptarFacturacion}
                    closeModalHandler={() => { setOpenModalAceptarFacturacion(false); }}
                    comprobante={comprobante}
                    esCarga={esCarga}
                    estado={estado}
                />
            }
            {
                openModalTracking &&
                <ModalTrackingFacturacion
                    open={openModalTracking}
                    closeModalHandler={() => { setOpenModalTracking(false); }}
                    comprobante={comprobante}
                />
            }
            {
                openModalEnviarAPagadas&&
                <ModalEnviarAPagadas 
                    open={openModalEnviarAPagadas}
                    close={()=>setOpenModalEnviarAPagadas(false)}
                    idTramiteCompras={comprobante.idTramitesCompras
                        }
                />
            }
            <TableRow>
                {Number(estadosFacturacionSelect) !== ESTADOS_AUDITORIAFACTURACION_COMPRAS.COMPROBANTE && (

                    <TableCell align="center" sx={{ padding: "10px" }}>
                        <InfoHistorialIcon onClick={() => setOpenModalTracking(true)} />
                    </TableCell>
                )}
                <TableCell style={{ textAlign: 'center' }}>{comprobante.idSolicitud ? comprobante.idSolicitud : "Sin cotizacion"}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.tipoComprobante}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.nroComprobante}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.razonSocial}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.cuit}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.carnet ? comprobante.carnet : "-"}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.idSolicitud ? `$${comprobante.valorCotizacion}` : `$${comprobante.totalComprobante}`}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{comprobante.solicitudPago ? comprobante.solicitudPago : "-"}</TableCell>
                {Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.COMPROBANTE && (
                    <TableCell>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={() => handleOpenModal(comprobante.idSolicitud)}>
                            Cargar Datos
                        </Button>
                    </TableCell>
                )
                }
                {Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.PENDIENTE_ENVIO && (
                    <TableCell>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={() => {
                                setEsCarga(true);
                                setOpenModalAceptarFacturacion(true);
                            }}>
                            Ver Datos
                        </Button>
                    </TableCell>
                )
                }
                {(Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.RECHAZADAS ||
                    Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.PENDIENTE_PAGO) && (
                        <>
                        <TableCell>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => {
                                    setEsCarga(false);
                                    setOpenModalAceptarFacturacion(true);
                                }}>
                                Ver
                            </Button>
                        </TableCell>
                         <TableCell>
                         <Button
                             variant='contained'
                             color='primary'
                             onClick={() => {
                                 setEsCarga(false);
                                 setOpenModalEnviarAPagadas(true);
                             }}>
                             Enviar a Pagadas
                         </Button>
                     </TableCell>
                     </>
                     )
                }
               
            </TableRow>
        </>
    )
});